import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MyHttpClientFactory, environment } from '@ups/xplat/core';
import { IDynamicResponseBody } from '../models/dynamic.interface';

function requiredDynamicApiUrl(): string {
  const url = environment.urls?.dynamicAPI;
  if (!url) {
    throw new Error('environment.urls.dynamicAPI is required');
  }
  return url;
}

/**
 * Reads who created a saved form response, for the form detail page's
 * own-record check (Bug 37038). Unlike DynamicRenderService.loadContainerResponse,
 * which never settles on an error, this resolves null on any failure so the page
 * can deny instead of hanging. DynamicResponse is a camelCase controller.
 */
@Injectable({ providedIn: 'root' })
export class FormResponseOwnerService {
  private readonly http: HttpClient = inject(
    MyHttpClientFactory
  ).createHttpClient(requiredDynamicApiUrl());

  loadCreatedBy(dynamicResponseId: string): Promise<string | null> {
    return firstValueFrom(
      this.http
        .get<IDynamicResponseBody>(`/api/DynamicResponse/${dynamicResponseId}`)
        .pipe(catchError(() => of(null)))
    ).then((response) => response?.createdBy ?? null);
  }
}
